import { Flex, Text } from "@jsq/ds/core";
import { AGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { capitalizeEachWord } from "~/utils/strings";
import { ProfileType } from "../../Profiles/types";
import { getProfileName } from "../../Profiles/utils";
import { fullHeightCell } from "../styles_vanilla.css";

interface Props {
  params: AGGridCellRenderParams;
  allProfilesForCase: ProfileType[];
}

export const ProfileCellRenderer = ({ params, allProfilesForCase }: Props) => {
  const currentProfile = allProfilesForCase.find((profile) => profile?.id === params.value);
  const currentProfileObjectType = currentProfile?.complianceObjectType;
  return (
    <Flex flexDirection="column" justifyContent="center" className={fullHeightCell}>
      <Text data-testid="profile-name-label" marginBottom="xs">
        {currentProfile ? getProfileName(currentProfile) : "--"}
      </Text>
      {currentProfile && (
        <Text variant="secondary-sm">{capitalizeEachWord(currentProfileObjectType)}</Text>
      )}
    </Flex>
  );
};
